<template>
  <div :class="certification ? 'login_wrap clear_mtop' : 'login_wrap'">
    <div
      :class="
        certification
          ? 'register_box login_register_form clear_mar'
          : 'register_box login_register_form'
      "
    >
      <h1 style="text-align: center; margin-top: 0">用户注册</h1>
      <el-form
        ref="endObj"
        :model="endObj"
        class="demo-ruleForm"
        label-position="left"
        :rules="rules"
        style="padding: 0px 40px"
      >
        <el-form-item prop="realName">
          <el-input placeholder="请输入用户名" v-model="endObj.realName">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            placeholder="请输入密码"
            v-model="endObj.password"
            type="password"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <div style="display: flex">
            <el-input
              placeholder="请输入手机号"
              v-model="endObj.phone"
              style="width: 210px"
            >
            </el-input>
            <el-button
              size="medium"
              @click="handleVerification"
              style="width: 100px; margin-left: 20px"
              >{{ content }}</el-button
            >
          </div>
        </el-form-item>
        <el-form-item prop="phoneCode">
          <el-input placeholder="请输入验证码" v-model="endObj.phoneCode">
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: end; margin-bottom: 0">
          <span
            >已有账号？<a
style="text-align: right"
@click="login"
              >去登录</a
            ></span
          >
        </el-form-item>
        <el-form-item class="cen" style="margin-bottom: 0">
          <el-button
            type="primary"
            class="next_btn"
            v-on:click="submitForm('endObj')"
            style="width: 100%"
            >注册</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <DialogVerificationCode
      v-if="dialogVisible"
      @handleClose="handleClose"
      @countDown="countDown"
      :dialogVisible="dialogVisible"
      :phone="this.endObj.phone"
    />
  </div>
</template>

<script>
import DialogVerificationCode from '@/components/Dialog/VerificationCode/index.vue';
import { validateRegistered, validateRedirect } from '@/utils/validate';
export default {
  name: 'Register',
  components: {
    DialogVerificationCode
  },
  data() {
    const validateMobilePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else {
        if (value !== '') {
          const reg = /^1[3456789]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error('请输入有效的手机号码'));
          }
        }
        callback();
      }
    };
    const checkData = (rule, value, callback) => {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能包含中文!'));
        } else {
          callback();
        }
      }
      callback();
    };
    return {
      certification: window.location.href.indexOf('certification') > -1,
      activeStep: 'createEnterprise',
      totalTime: 60,
      disabled: true,
      dialogVisible: null,
      errorUserMsg: null,
      redirect: '/manage/general/',
      content: '发送验证码',
      storeDomain: false,
      endObj: {
        realName: '',
        password: '',
        phone: '',
        phoneCode: '',
        domain: ''
      },
      rules: {
        realName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 16,
            message: '用户名长度在2-16位',
            trigger: 'blur'
          },
          {
            validator: checkData,
            trigger: 'change'
          }
        ],
        phone: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobilePhone
          }
        ],
        phoneCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 6,
            message: '请输入正确验证码',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 255,
            message: '密码长度在6-255位',
            trigger: 'blur'
          }
        ],
        domain: [
          {
            required: true,
            message: '请输入企业域',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    const storeDomains =
      JSON.parse(window.sessionStorage.getItem('storeDomain')) || false;
    this.storeDomain = storeDomains;
  },
  methods: {
    login() {
      this.$router.push({
        name: 'login'
      });
    },
    handleVerification() {
      this.dialogVisible = null;
      this.errorUserMsg = null;
      this.$refs.endObj.validateField('phone', (moneyError) => {
        if (!moneyError) {
          if (!this.disabled) return;
          this.$store
            .dispatch('checkPhone', {
              phone: this.endObj.phone
            })
            .then(() => {
              this.dialogVisible = true;
            })
            .catch((err) => {
              if (err && err.code) {
                if (err.code === 3001) {
                  this.errorUserMsg = '账户不存在';
                }
                if (err.code === 3004) {
                  this.$message.warning(
                    '当前手机号已注册，请使用该手机号或账号密码登陆。'
                  );
                }
              }
            });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    countDown() {
      if (!this.disabled) return; // 改动的是这两行代码
      this.disabled = false;
      this.dialogVisible = false;
      this.content = this.totalTime + 's';
      const _th = this;
      const clock = window.setInterval(() => {
        _th.totalTime--;
        _th.content = _th.totalTime + 's';

        if (_th.totalTime < 0) {
          window.clearInterval(clock);
          _th.content = '发送验证码';
          _th.totalTime = 60;
          _th.disabled = true; // 这里重新开启
        }
      }, 1000);
    },
    handleLogin() {
      this.$router.push({
        name: this.certification ? 'certificationLogin' : 'login'
      });
    },
    nextSteep(name, parameter) {
      this.activeStep = name;
      if (parameter) {
        this.endObj = parameter;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const obj = this.endObj;
          obj.email = '';
          obj.domain = 'rainbond';
          this.$store
            .dispatch('Regist', obj)
            .then((res) => {
              if (res) {
                this.$store
                  .dispatch('GetUserInfo')
                  .then((res) => {
                    if (res && res.roles) {
                      if (res.roles.indexOf('企业管理员') != -1 || res.roles.indexOf('应用管理员') != -1) {
                        window.sessionStorage.setItem('isAdmin', true);
                      } else {
                        if (res.roles.indexOf('普通用户') != -1) {
                          window.sessionStorage.setItem('isAdmin', false);
                        } else if (res.roles.indexOf('分享用户角色') != -1) {
                          window.sessionStorage.setItem('isAdmin', false);
                        } else {
                          window.sessionStorage.setItem('isAdmin', true);
                        }
                      }
                    }
                  })
                  .catch((re) => {});
                if (res.token && this.certification) {
                  this.fetchAccessKeyApi();
                } else {
                  if (window.sessionStorage.getItem('path')) {
                    window.location = window.sessionStorage.getItem('path');
                  } else {
                    if (
                      JSON.parse(window.sessionStorage.getItem('storeDomain'))
                    ) {
                      window.location = validateRedirect(
                        `/marketplace`
                      );
                    } else {
                      window.location = validateRedirect(this.redirect);
                    }
                  }
                  window.sessionStorage.removeItem('path');
                }
              }
            })
            .catch((err) => {
              if (err && err.code) {
                if (err.code === 1008) {
                  obj.code = 1008;
                  this.$emit('nextSteep', 'registeredSuccess', obj);
                }
                validateRegistered(err.code, (msg, errname) => {
                  this.errorEmailMsg =
                    (errname === 'errorEmailMsg' && msg) || null;
                  this.errorVerificationMsg =
                    (errname === 'errorVerificationMsg' && msg) || null;
                  this.errorPhoneMsg =
                    (errname === 'errorPhoneMsg' && msg) || null;
                });
              }
            });
        }
      });
    },
    fetchAccessKeyApi() {
      this.$store
        .dispatch('GetUserInfo')
        .then((res) => {
          if (res && res.eid) {
            addAccessKeyApi({
              eid: res.eid,
              note: `用于Rainbond平台从本市场安装应用(${this.getParentUrl()})`,
              actions: ['ReadInstall', 'OnlyRead', 'Write']
            })
              .then((res) => {
                window.parent.postMessage(
                  {
                    accessKey: res.accessKey
                  },
                  '*'
                );
                this.FedLogOut();
              })
              .catch((err) => {
                this.FedLogOut();
                errorHandle(err);
              });
          }
        })
        .catch(() => {
          this.FedLogOut();
        });
    }
  }
};
</script>

<style lang="scss">
.input-with-select .el-input-group__prepend {
  background: #f9f9f9;
}
.login_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  .boeLogo {
    width: 611px;
  }
  .clear_mar {
    margin: 0 auto !important;
  }
  .register_box {
    margin: 30px auto;
    width: 480px;
    background: #ffffff;
    min-height: 400px;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 36px;
    .tit_box {
      display: flex;
      justify-content: space-between;
      h1 {
        font-size: 16px;
      }
      span {
        opacity: 0.8;
      }
    }
    .steps_box {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      div {
        background-color: #fff;
        color: #4d4d4f;
        border-radius: 4px;
        padding: 10px 18px;
      }
      .active_step {
        background-color: #1890ff;
        color: #fff;
      }
    }
    .tips {
      margin-top: 10px;
      opacity: 0.6;
    }
    .title {
      font-size: 16px;
      margin: 20px 0 10px;
    }
    .agree_txt {
      opacity: 0.8;
    }
    .el-form-item__label {
      font-size: 16px;
    }
  }
}
.clear_mtop {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/register/page.vue